<eca-icon-definitions></eca-icon-definitions>
<eca-app-shell id="eca-app-shell">
  <router-outlet (activate)="onActivate()"></router-outlet>
</eca-app-shell>
